import { Pipe, PipeTransform } from '@angular/core';
import { CartitemsService } from './providers/cartitems.service';

@Pipe({
  name: 'orderstatus'
})
export class OrderstatusPipe implements PipeTransform {
  constructor(private cartitems : CartitemsService){}
  transform(value: any, args: any): any {

    let orderSort = []
    for(let i=0; i<value.length; i++) {
     
    if(args=='All Statuses' || args=='Todos los estados')
    orderSort=value
    else{
      if((value[i].order_status) === args){
        orderSort.push(value[i])
        // return orderSort;
      }
    }
     
    }
    return orderSort;
    }
//   transform(items: any[], filter: any): any {
//     if (!items || !filter) {
//         return items;
//     }
//     let status = this.cartitems.orderstatuses[filter];
//     return items.filter(item => status === 0 || item.status === status);
//    // return items.filter(item => status === 0 || item.status === status || (status === 3 && item.status === 2));
    
// }

}



// WEBPACK FOOTER //
// ./src/app/orderstatus.pipe.ts